"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrodeAbilityHandler = exports.CorrodeActorAbilityFactory = exports.CorrodeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class CorrodeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Corrode;
        this.__typeName = "Corrode";
    }
}
exports.CorrodeAbilityArgs = CorrodeAbilityArgs;
let CorrodeActorAbilityFactory = class CorrodeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Corrode", "AllEnemies", 0);
    }
};
CorrodeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Corrode")
], CorrodeActorAbilityFactory);
exports.CorrodeActorAbilityFactory = CorrodeActorAbilityFactory;
let CorrodeAbilityHandler = class CorrodeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: Array(2).fill(0).map(() => (0, Random_1.randomElement)(enemies))
                .map(targetId => ({
                targetId,
                path: "line",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
                ],
                jitter: (0, Random_1.random)(250, 750),
                type: "GreenSlime"
            })),
            onHit: (sequence, _attack, _damages, { targetId }) => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId), "BloodyPoisonCloud"))
        });
    }
};
CorrodeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Corrode)
], CorrodeAbilityHandler);
exports.CorrodeAbilityHandler = CorrodeAbilityHandler;
